/** @jsx jsx */
import { jsx } from "theme-ui"

const Footer = () => (
  <footer
    className="site-footer"
    sx={{
      bg: "siteColor",
    }}
  >
    <div className="container">
      <p>
        Website Designed
        by <a href='https://www.kyle-richey.com' target='_blank' rel='noreferrer'>Kyle Richey</a>
      </p>
    </div>
  </footer>
)

export default Footer
